import api from './index'

export function askForEmailConfirmation({
  email,
  country,
  language,
  magicLink,
}) {
  return api.post('/api/email-validation/send-email', {
    email,
    country,
    language,
    magicLink,
  })
}

export function confirmEmail(leadToken) {
  return api.post('/api/email-validation/confirm', { leadToken })
}

export default {
  askForEmailConfirmation,
  confirmEmail,
}
